<mat-select [formControl]="skjemakontroll()"
            [compareWith]="erValgt"
            panelClass="velg-lokale--alternativer"
            [placeholder]="placeholder() || standardPlaceholder"
            panelWidth="200px"
            data-testid="språk-felt"
            #lokalevelger>
  <mat-select-trigger>
    @if(valgtLokale()){
      <lokale [lokale]="valgtLokale()"/>
    }
    </mat-select-trigger>
  @for (lokale of tilgjengeligeLokaler; track $index) {
    <mat-option [value]="lokale['språk']">
      <lokale [lokale]="lokale"/>
    </mat-option>
  }
</mat-select>
